const MAX_NUMERIC_LENGTH = 14;

/**
 * Blocks any keypress that would make a numeric field invalid.
 *
 * @param {KeyboardEvent} e Keypress event from a numeric input.
 */
export const handleOnlyNumber = e => {
    const x = e.which || e.keycode;
    if (!(x >= 48 && x <= 57)) e.preventDefault();
    if (e.target.value.length > MAX_NUMERIC_LENGTH) e.preventDefault();
};
